export default __webpack_public_path__ + "assets/webgl/complete-6.0c620992.jpg";